import { render, staticRenderFns } from "./item-details.vue?vue&type=template&id=abc90c26&scoped=true"
import script from "./item-details.vue?vue&type=script&lang=js"
export * from "./item-details.vue?vue&type=script&lang=js"
import style0 from "./item-details.vue?vue&type=style&index=0&id=abc90c26&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc90c26",
  null
  
)

export default component.exports